export default __webpack_public_path__ + "static/media/squareOne.e6e7ff3c.png";